import { AccountInfo } from './account-info';

export interface AccessControlCSRParam {
    allowPasswordReset?: boolean;
    allowUpdatePhone?: boolean;
    allowUpdateEmail?: boolean;
    allowUnlockMFADevices?: boolean;
    allowRevokePasskeys?: boolean;
    allowUnlockUser?: boolean;
    allowDisableUser?: boolean;
    allowEnableUser?: boolean;
    allowDeleteUser?: boolean;
    allowSendOTP?: boolean;
    allowResendInvitation?: boolean;
}

export interface WidgetConfig {
    accessControl?: AccessControlCSRParam | SelfServiceControlParam;
    user?: AccountInfo;
    policyID: string;
    potentialNewUser?: string;
};

export interface SelfServiceControlParam {
    // placeholder
    placeholder?: boolean;
}

export interface CSRParams {
    nwAccountURI?: string;
    csrID?: string;
    accessControl?: AccessControlCSRParam;
}

export interface SelfServiceParams {
    data: string;
}

export class SelfServicePayload implements SelfServiceParams {
    data: string;

    constructor(data: SelfServiceParams) {
        this.data = data.data;
    }
}

export class CSRParamsPayload implements CSRParams {
    accessControl: AccessControlCSRParam;
    csrID: string;
    nwAccountURI: string;

    constructor(data: CSRParams) {
        this.nwAccountURI = `acct:${encodeURIComponent(data.nwAccountURI)}@tpi.nwie.net`;
        this.csrID = data.csrID;
        this.accessControl = {
            allowPasswordReset: data?.accessControl?.allowPasswordReset ?? false,
            allowUpdatePhone: data?.accessControl?.allowUpdatePhone ?? false,
            allowUpdateEmail: data?.accessControl?.allowUpdateEmail ?? false,
            allowUnlockMFADevices: data?.accessControl?.allowUnlockMFADevices ?? false,
            allowRevokePasskeys: data?.accessControl?.allowRevokePasskeys ?? false,
            allowUnlockUser: data?.accessControl?.allowUnlockUser ?? false,
            allowDisableUser: data?.accessControl?.allowDisableUser ?? false,
            allowEnableUser: data?.accessControl?.allowEnableUser ?? false,
            allowDeleteUser: data?.accessControl?.allowDeleteUser ?? false,
            allowSendOTP: data?.accessControl?.allowSendOTP ?? false,
            allowResendInvitation: data?.accessControl?.allowResendInvitation ?? false
        };
    }
}

export class ProxyRegistrationPayload {
    nwAccountURI: string;
    constructor(nwAccountURI: string) {
        this.nwAccountURI = `acct:${encodeURIComponent(nwAccountURI)}@tpi.nwie.net`;
    }
}